// navigacija u side meniju
export function generateClientNav() {
  return [
    {
      component: 'CNavItem',
      name: 'Home Page',
      to: `/home`,
      icon: 'cil-home'
    },
    {
      component: 'CNavItem',
      name: 'Plan a trip',
      to: `/tripplan`,
      icon: 'cil-paper-plane'
    }
  ];
}
